//es5兼容
import 'babel-polyfill'
import Vue from 'vue'

//解码
let jGlobalSetting=''
if(process.env.NODE_ENV == 'production' && GlobalSetting){
    jGlobalSetting=JSON.parse(window.atob(GlobalSetting))
}

// import 'lib-flexible/flexible'

//加载进度
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
Vue.use(VueVideoPlayer, /* {
    options: global default options,
    events: global videojs events
  } */)

//vant
import 'vant/lib/index.less';
import { Cell, CellGroup, Col, Row, Button, Icon, Image as VanImage, Lazyload, Loading, Popup, Toast, Calendar, Cascader, Field, NavBar, Swipe, SwipeItem, CountDown, List, PullRefresh, Search, Checkbox, CheckboxGroup, Stepper, SubmitBar, Dialog, Sticky, Rate, Sku, Circle, DropdownMenu, DropdownItem, Tab, Tabs, Switch, Area, Form, Sidebar, SidebarItem, IndexBar, IndexAnchor, RadioGroup, Radio, TreeSelect, Badge, DatetimePicker, Card,Step, Steps,Uploader } from 'vant';

//修改默认
//Dialog.setDefaultOptions({ closeOnClickOverlay: true, confirmButtonColor: '#B0294A', confirmButtonText: i18n.t('confirm'), cancelButtonText: i18n.t('Cancel') })
//Toast.setDefaultOptions('loading', { forbidClick: true, overlay: false, duration: 0, loadingType: 'circular', className: 'goLoadingBase' });
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Col);
Vue.use(Row);
Vue.use(Button);
Vue.use(Icon);
Vue.use(VanImage);
Vue.use(Lazyload);
Vue.use(Loading);
Vue.use(Popup);
Vue.use(Toast);
Vue.use(Calendar);
Vue.use(Cascader);
Vue.use(Field);
Vue.use(NavBar);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(CountDown);
Vue.use(List);
Vue.use(PullRefresh);
Vue.use(Search);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Stepper)
Vue.use(SubmitBar)
Vue.use(Dialog)
Vue.use(Sticky)
Vue.use(Rate)
Vue.use(Sku)
Vue.use(Circle)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Switch)
Vue.use(Area)
Vue.use(Form)
Vue.use(Sidebar)
Vue.use(SidebarItem)
Vue.use(IndexBar)
Vue.use(IndexAnchor)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(TreeSelect)
Vue.use(Badge)
Vue.use(DatetimePicker)
Vue.use(Card)
Vue.use(Step)
Vue.use(Steps)
Vue.use(Uploader); 
Vue.directive('tableScroll', {
    bind (el, binding) {
    	// el-table 内容滚动区域
        const bodyWrap = el.querySelector('.el-table__body-wrapper')
        let time = 300
        let timer=null
        bodyWrap.addEventListener('scroll', function () {
            if (timer) return
            timer = setTimeout(() => {
                let sign = 50
                // 滚动到底部
                const scrollTop = bodyWrap.scrollTop
                // 变量windowHeight是可视区的高度
                const domHeight = bodyWrap.offsetHeight
                // 变量scrollHeight是滚动条的总高度
                const scrollHeight = bodyWrap.scrollHeight 
                const scrollDistance = scrollHeight - scrollTop -  domHeight
                if (scrollDistance <= sign) {
                    binding.value()
                }
               
              clearTimeout(timer)
              timer=null 
            }, time)
           
        })
    }
}) 
//配置
NProgress.configure({
    easing: 'ease',  // 动画方式
    speed: 500,  // 递增进度条的速度
    showSpinner: false, // 是否显示加载ico
    trickleSpeed: 200, // 自动递增间隔
    minimum: 0.3 // 初始化时的最小百分比
})

//公共样式
import '@/styles/index.scss'

//normalize
import 'normalize.css/normalize.css' // A modern alternative to CSS resets
//configfont
import '@/assets/configfont/iconfont.css'
//font
import '@/assets/font/iconfont.css'


import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
//主题色
import '@/styles/element-variables.scss'

//默认设置
const Message = ElementUI.Message
const types = ['success', 'info', 'warning', 'error']
types.forEach(type => {
  Message[type] = options => {
    if (typeof options === 'string') {
      options = { message: options }
    }
    // 自定义默认配置项
    Message({ type, duration: 1500,  ...options })
  }
})
Vue.use(ElementUI);

//路由
import router from './router'

//多语种
import i18n from '@/utils/i18n'
Vue.prototype.i18n=i18n

//配置信息
import config from '@/config'
window.WKConfig=config
Vue.prototype.WKConfig=config

//公共方法
import conFunction from '@/utils/conFunction'
Vue.prototype.conFunction=conFunction

//api
import api from './api'
Vue.prototype.$api=api

import moment from 'moment'
Vue.prototype.$moment=moment

import App from './App'

//Vuex
import store from './store'
Vue.prototype.$store=store

//Vuex
import {checkAuth,updateUserData} from '@/utils/auth'

//路由监控
router.beforeEach(async(to, from , next) => {
    console.error('to',to)
    console.error('from',from)
    localStorage.setItem('dealLang',store.state.app.lang)
    //GTO  單獨處理 不刷新頁面
    if(from.path=='/PropertyGTO/index'&&from.path==to.path){
         next(false)
    }else{
         //进度条
        NProgress.start();
        //判断登录状态
        if(to.meta.code=='router_demo' || to.meta.code=='router_noticeView'){
            next();
        }else{
            
            if(to.meta.code=='router_login' || to.meta.code=='router_loginTemporary'){
                if(checkAuth()){
                    next({path:'/index'})
                }else{
                    next();
                }
            }else{
                if(!checkAuth()){
                    next({path:'/login'})
                }else{
                    //更新用户信息
                    updateUserData().then(()=>{
                        //判断路由
                        //Customerphone_RepairReport
                        var noAccessRouterPath=['jumpPC','KeyInfoInfo_Eforms','KeyInfoInfo_keyinfo','Customerphone_RepairReport','KeyInfoInfo_contact','FittingOut_WorkApplication','FittingOut_Submission']
                        let historyUrl=sessionStorage.getItem('oldUrl')?JSON.parse(sessionStorage.getItem('oldUrl')):[];
                        if(window.screen.width<=992||navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)){
                            //console.error(to.meta.menucode,from.meta.menucode)
                            //debugger
                            if(noAccessRouterPath.includes(to.meta.menucode)){
                                if(to.meta.menucode=='jumpPC'){
                                    if(from.meta.menucode=='jumpPC'){
                                        //去和來同時 jumpPC 不做處理
                                        next()   
                                    }else{
                                        next()                    
                                    }
                                }else{
                                    next('/jumpPC')                                   
                                }
                            }else{                         
                                next()                                                                    
                            }
                        }else{
                        
                            next()
                        }
                    })
                }
            }
        }
    }
})

//结束
router.afterEach((to,from) => {
    NProgress.done()
})

//公共组件
import defaultImage from "@/components/images"   //引入组件
Vue.component("default-image",defaultImage);
import footerSlide from "@/components/footerSlide"   //引入组件
Vue.component("footerSlide",footerSlide);
import pageTitle from "@/components/pageTitle"   //引入组件
Vue.component("pageTitle",pageTitle);

//md5
import md5 from 'js-md5';
Vue.prototype.$md5=md5

//事件传递
import VueBus from 'vue-bus'
Vue.use(VueBus)

Vue.config.productionTip = false
Vue.config.performance = true;

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    i18n,
    render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js